import { render } from "./ProduceList.vue?vue&type=template&id=71339351&scoped=true"
import script from "./ProduceList.vue?vue&type=script&lang=js"
export * from "./ProduceList.vue?vue&type=script&lang=js"

import "./ProduceList.vue?vue&type=style&index=0&id=71339351&scoped=true&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/wanfei-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71339351"]])

export default __exports__